import React from 'react'
import ModalComponent from '../../../../components/modal/index';
import PatientDetails from '../../scenes/registers/scenes/patient-details/index';
import { format } from 'date-fns';

class Portal extends React.Component {

}

class DoctorDetails extends React.Component {
    render() {
        if(!this.props.isActive || !this.props.doctor)
            return null;

        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Detalles</p>
                    </header>
                    <section className="modal-card-body">
                        <p><b>Nombre: </b>{ `${this.props.doctor.name} ${this.props.doctor.lastname}` }</p> <br />
                        <p><b>Correo: </b>{this.props.doctor.email}</p> <br />
                        <p><b>Teléfono: </b>{this.props.doctor.phone}</p><br />
                        <p><b>Estado: </b>{this.props.doctor.status}</p>
                    </section>
                </div>
            </ModalComponent>
        );
    }
}

export default function withDoctorModal(Component) {
    return class WithDoctorModal extends React.Component {
        state = {
            isActive: false,
            doctor: null,
            received: null
        }

        openModal = (doctor) => this.setState({isActive: true,doctor: doctor})
        closeModal = () => this.setState({isActive: false, doctor: null})

        render() {
            return(
                <React.Fragment>
                    <Component {...this.props} openDoctorDetails={this.openModal} />
                    <DoctorDetails doctor={this.state.doctor}
                        isActive={this.state.isActive}
                        close={this.closeModal}
                    />
                </React.Fragment>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/hocs/doctor-details/index.js